import { useEffect, useState } from "react"
import {
  Maybe,
  ResourcesFragment,
  useGetResourceByIdQuery,
} from "../generated/graphql"
import { useGraphQLClient } from "./useGraphQLClient"

export const useGetResourceById = (id: number = -1) => {
  const [resource, setResource] =
    useState<Maybe<ResourcesFragment | undefined>>(undefined)
  const graphQLClient = useGraphQLClient()
  const { data: contentData } = useGetResourceByIdQuery(graphQLClient, {
    id: id,
  })
  useEffect(() => {
    setResource(contentData?.resources_by_pk)
  }, [setResource, contentData?.resources_by_pk])
  return resource
}
